import { useQueryParam } from 'works/legacy/services/query-params-service';

export function useRedirectPath(key = 'redirect_path') {
  const redirectPath = useQueryParam(key);
  return redirectPath?.startsWith('/works') ? redirectPath : null;
}
